import React from 'react';
import PropTypes from 'prop-types';
import { isArray } from 'lodash';

export default class CheckboxAsRadioWrapper extends React.Component {
  componentWillMount = () => {
    if(!isArray(this.props.input.validations.val)) {
      this.props.input.validations.val = [this.props.input.validations.val.toString()];
    }
  }

  componentWillUpdate() {
    if(!isArray(this.props.input.validations.val)) {
      this.props.input.validations.val = [this.props.input.validations.val.toString()];
    }
  }

  handleChange = event => {
    let values = [];

    if (event.target.checked) {
      values.push(event.target.value);
      this.props.input.validations.reset();
    } else {
      values.splice(values.indexOf(event.target.value), 1);
    }

    this.props.onChange(this.props.input, values);
  }

  onBlur = () => {
    if (this.props.onBlur) this.props.onBlur();
  }

  render() {
    let errors = this.props.input.validations.errors.map(e => e);

    return <span onBlur={this.onBlur}>
      <input type={this.props.type || "checkbox"}
        value={this.props.value}
        checked={this.props.input.validations.val.indexOf(this.props.value.toString()) >= 0}
        onBlur={() => this.props.valid(this.props.input)}
        onChange={this.handleChange}
        tabIndex={this.props.tabOrder}
        className={this.props.inputClass}
        disabled={this.props.editing === false && true}/>

      {errors.length > 0 &&
       !this.props.suppressError && <ul>
        {errors.map((e, i) => e.message !== '' && <li key={i} className="error">
          {e.message}
        </li>)}
      </ul>}
    </span>;
  }
}

CheckboxAsRadioWrapper.PropTypes = {
  type: PropTypes.string,
  input: PropTypes.object.isRequired,
  onChange: PropTypes.func,
  valid: PropTypes.func,
  validations: PropTypes.func,
  tabOrder: PropTypes.string,
  editing: PropTypes.bool
};



// WEBPACK FOOTER //
// ./src/components/Wrappers/CheckboxAsRadioWrapper.js